import React from "react";
import { ListItem } from "./ListItem";
import { MCStateContext } from "../../..";

import "./style.scss";

const ITEM_TEXT = {
  TUBE_BALANCED: "TubeBalanced",
  LID_CLOSED: "LidClosed",
};

export function WarningBlock() {
  const { balanced, isLidOpen } = React.useContext(MCStateContext);

  return (
    <div className="mc_warningBlock">
      <ListItem text={ITEM_TEXT.TUBE_BALANCED} isSuccess={balanced} />
      <ListItem text={ITEM_TEXT.LID_CLOSED} isSuccess={!isLidOpen} />
    </div>
  );
}

WarningBlock.propTypes = {};

WarningBlock.defaultProps = {};
